import { BaseStoredItem } from "./BaseStoredItem";

export class StoredAvailableNow extends BaseStoredItem<boolean> {
  storageKey() {
    return "availableNow";
  }
}
